import React from "react";
import Hero from "../../components/services/webdev/Hero";
import Webservices from "../../components/services/webdev/Webservices";
import DevelopmentProcess from "../../components/services/webdev/Developmentprocess";
import Webdevmarket from "../../components/services/webdev/Webdevmarket";
import WhyChooseUs from "../../components/services/webdev/Whychooseus";
import KeyFeatures from "../../components/services/webdev/keyFeathers";
import WebDetailed from "../../components/services/webdev/WebDetailed";
import Webdevtool from "../../components/services/webdev/Webdevtool";
import Industry from "../../components/services/webdev/Industry";
import { Helmet } from "react-helmet-async";
function WebDev() {
  return (
    <div>
      <Helmet>
        <title>
          Website Development Company | Custom Web Development Services
        </title>

        <meta
          name="description"
          content="Professional website development services including business websites, web applications, SaaS platforms, e-commerce development, React.js and Node.js solutions."
        />

        <meta
          name="keywords"
          content="Website Development Company, Web Development Services, Custom Website Development, Web Application Development, React Development, Node.js Development, E-Commerce Development"
        />

        <link rel="canonical" href="https://webxsecure.in/web-development" />

        <meta
          property="og:title"
          content="Professional Website Development Services"
        />

        <meta
          property="og:description"
          content="Custom website development, web applications, SaaS solutions and e-commerce development for businesses."
        />

        <meta property="og:image" content="https://webxsecure.in/logo.png" />

        <meta
          property="og:url"
          content="https://webxsecure.in/web-development"
        />

        <meta property="og:type" content="website" />

        {/* Service Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Website Development Services",
            provider: {
              "@type": "Organization",
              name: "Web X Secure",
            },
            serviceType: "Web Development",
            areaServed: "India",
            url: "https://webxsecure.in/web-development",
          })}
        </script>

        {/* Breadcrumb */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Web Development",
                item: "https://webxsecure.in/web-development",
              },
            ],
          })}
        </script>
      </Helmet>
      <Hero />
      <Webservices />
      <DevelopmentProcess />
      <Webdevmarket />
      <WhyChooseUs />
      <Webdevtool />
      <KeyFeatures />
      <Industry />
      <WebDetailed />
    </div>
  );
}

export default WebDev;
